import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { setReadNum, getReadNumNormal, getReadNumWeight } from '@src/services/api';
import { asyncGetNativePlayNum } from '@src/utils/playNumUnit';

class ReadNum extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        readNum: 0,
    };

    moreTenThousands = (num) => {
        if (!num) return num;

        const numData = Number(num);

        return numData > 9999 ? `${Math.floor(numData / 1000) / 10}万` : num;
    };

    async componentDidMount() {
        const {
            hasOpen,
            copyrightSwitch,
            hasWeight,
            base62Id,
            hasCopyRight,
            createTime = '',
            searchPath = '',
            searchPathFilter = '',
            wemediaEAccountId = '',
            guid,
            wemediaIds,
        } = this.props.content;
        let readNum = 0;
        const specialWemediaId = wemediaIds?.split?.(',') || [];

        if (hasOpen === '1') {
            try {
                let publishTime = createTime.replace(/-/g, '/');
                let serviceid = 5;

                // 按照searchPath特殊处理 start
                const searchPathArray = (searchPath && searchPath?.split?.(',')) || [];
                const searchPathFilterArray = (searchPathFilter && searchPathFilter?.split?.(',')) || [];

                if (searchPathArray.length > 0 && searchPathFilterArray.length > 0) {
                    let flag = false;

                    searchPathFilterArray.forEach((filterItem) => {
                        searchPathArray.forEach((articleItem) => {
                            if (articleItem.indexOf(filterItem) === 0) {
                                flag = true;
                            }
                        });
                    });

                    if (flag) {
                        serviceid = 6;
                    }
                }
                // 按照searchPath特殊处理 end

                publishTime = new Date(publishTime).getTime() || new Date().getTime();
                publishTime = Math.floor(publishTime / 1000);
                await setReadNum(base62Id, publishTime);

                if (serviceid === 6) {
                    // searchPath地方站处理
                    if (hasWeight === '1') {
                        readNum = await getReadNumNormal(base62Id, publishTime, serviceid);
                    } else {
                        readNum = await getReadNumWeight(base62Id, publishTime, serviceid);
                    }

                    readNum = this.moreTenThousands(readNum);
                } else {
                    // 其余按pc端视频处理
                    const playNum = await asyncGetNativePlayNum([{ guid: guid || base62Id }]);

                    readNum = playNum ? playNum?.[guid || base62Id] : 0;

                }

                if ((copyrightSwitch === '2' && !hasCopyRight) || (copyrightSwitch === '3' && hasCopyRight)) {
                    readNum = 0;
                }

                // // 按照自媒体wemediaEAccountId特殊处理 start
                // if (specialWemediaId.includes(String(wemediaEAccountId))) {
                //     const playNum = await asyncGetPlayNum([{ guid }]);

                //     readNum = playNum ? playNum?.[guid] : 0;
                // }
                // // 按照自媒体wemediaEAccountId特殊处理 end

                this.setState({
                    readNum,
                });
            } catch (e) {
                console.log(e, 'readNum error');
            }
        }
    }

    render() {
        const { readNum } = this.state;
        const { videoSubText } = this.props.content;

        return readNum ? (
            <div className={styles.readNum}>
                {readNum}
                {videoSubText}
            </div>
        ) : null;
    }
}

export default errorBoundary(ReadNum);
